import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb = ({ items }: BreadcrumbProps) => {
  return (
    <nav aria-label="Breadcrumb" className="py-3 sm:py-4 overflow-x-auto scrollbar-hide">
      <ol className="flex items-center gap-1 sm:gap-2 text-xs sm:text-sm whitespace-nowrap" itemScope itemType="https://schema.org/BreadcrumbList">
        {items.map((item, index) => (
          <li
            key={index}
            className="flex items-center gap-1 sm:gap-2"
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            {item.path ? (
              <>
                <Link
                  to={item.path}
                  className="text-accent-cyan hover:text-accent-cyan/80 transition-colors"
                  itemProp="item"
                >
                  <span itemProp="name">{item.label}</span>
                </Link>
                <meta itemProp="position" content={String(index + 1)} />
                {index < items.length - 1 && (
                  <i className="ri-arrow-right-s-line text-gray-500 text-sm"></i>
                )}
              </>
            ) : (
              <>
                <span className="text-gray-400" itemProp="name">{item.label}</span>
                <meta itemProp="position" content={String(index + 1)} />
              </>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
